import React from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@roger/ui-components';
import type { WoundResponse } from '../../services/api';
import WoundTableRow from './WoundTableRow';

interface WoundsTableProps {
  wounds: WoundResponse[];
  canDiscontinue?: boolean;
  onEdit: (wound: WoundResponse) => void;
  onDelete: (wound: WoundResponse) => void;
  onDiscontinue: (
    woundId: string,
    date: Date,
    reason: string,
    comments: string
  ) => Promise<void>;
  onOpenAssessments: (wound: WoundResponse) => void;
}

const WoundsTable: React.FC<WoundsTableProps> = ({
  wounds,
  canDiscontinue = false,
  onEdit,
  onDelete,
  onDiscontinue,
  onOpenAssessments,
}) => {
  // Active wounds first, then healed — within each group, most recently created first
  const sorted = [...wounds].sort((a, b) => {
    const aHealed = !!a.discontinued_date;
    const bHealed = !!b.discontinued_date;
    if (aHealed !== bHealed) return aHealed ? 1 : -1;
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className='w-[120px]'>Status</TableHead>
          <TableHead>Wound</TableHead>
          <TableHead className='w-[150px]'>Onset</TableHead>
          <TableHead className='w-[240px]'>Assessments</TableHead>
          <TableHead className='w-[260px]'>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {sorted.map(wound => (
          <WoundTableRow
            key={wound.id}
            wound={wound}
            assessmentCount={wound.assessment_count ?? 0}
            canDiscontinue={canDiscontinue}
            onEdit={onEdit}
            onDelete={onDelete}
            onDiscontinue={onDiscontinue}
            onOpenAssessments={onOpenAssessments}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default WoundsTable;
